import React from 'react';
interface FormFieldProps {
  label: string;
  value: string;
  suggestion: string;
  onChange: (value: string) => void;
  onAccept: () => void;
  onReject?: () => void;
  type?: string;
}
export const FormField: React.FC<FormFieldProps> = ({
  label,
  value,
  suggestion,
  onChange,
  onAccept,
  onReject,
  type = 'text'
}) => {
  const handleReject = () => {
    onChange(''); // Clear the input field value
    if (onReject) {
      onReject(); // Clear the suggestion in parent component
    }
  };
  return <div data-id="element-23">
      <label className="block text-sm font-medium mb-1" data-id="element-24">{label}</label>
      <div className="relative" data-id="element-25">
        <input type={type} value={value} onChange={e => onChange(e.target.value)} className="w-full p-2 border rounded-md bg-background" data-id="element-26" />
        {suggestion && !value && <div className="absolute right-2 top-2 flex items-center gap-2" data-id="element-27">
            <span className="text-sm text-muted-foreground italic" data-id="element-28">
              {suggestion}
            </span>
            <div className="flex gap-1" data-id="element-29">
              <button type="button" onClick={handleReject} className="text-xs border border-input hover:bg-secondary/50 text-muted-foreground px-2 py-0.5 rounded-md transition-colors" data-id="element-30">
                Reject
              </button>
              <button type="button" onClick={onAccept} className="text-xs bg-primary text-primary-foreground px-2 py-0.5 rounded-md hover:bg-primary/90 transition-colors" data-id="element-31">
                Accept
              </button>
            </div>
          </div>}
      </div>
    </div>;
};